import { ReactElement, memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import PopupDialog from "../../../components/elements/PopupDialog/PopupDialog";
import ChangeDineInTakeaway from "./ChangeDineInTakeaway";
import "./ChangeDineInTakeawayModal.scss";
import "./ChangeDineInTakeawayModal_flint.scss";
import "./ChangeDineInTakeawayModal_kokoro.scss";
import "./ChangeDineInTakeawayModal_pdd.scss";
import "./ChangeDineInTakeawayModal_shabuDays.scss";
import "./ChangeDineInTakeawayModal_torikizoku.scss";
import "./ChangeDineInTakeawayModal_wang.scss";
import "./RemoveCartItemModal.scss";
import { useDineInTakeawayOption } from "./useDineInTakeawayOption";

interface IProps {
	isOpen: boolean;
	closeFn: () => void;
}

const ChangeDineInTakeawayModal = ({ isOpen, closeFn }: IProps): ReactElement => {
	const { option, confirm, cancelConfirm, selectTakeaway } = useDineInTakeawayOption(closeFn);

	const { t } = useTranslation();

	const buttons = useMemo(
		() => [
			{
				text: t("Generic.confirm"),
				onClick: confirm,
				className: "BtnConfirm",
			},
		],
		[t, confirm]
	);

	return (
		<PopupDialog
			open={isOpen}
			onClose={cancelConfirm}
			content={<ChangeDineInTakeaway onChange={selectTakeaway} value={option} />}
			buttons={buttons}
			data-testid="ConfirmDineInTakeaway"
			className="ConfirmDineInTakeaway"
		/>
	);
};

export default memo(ChangeDineInTakeawayModal);
